function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import cx from 'classnames';
import WithSx from '../../hoc/WithSX/WithSx';
import { propTypes, defaultProps } from './props';
import { jsx as ___EmotionJSX } from "@emotion/react";
const TAGS = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  p: 'p',
  span: 'span',
  strong: 'strong',
  b: 'b',
  em: 'em',
  blockquote: 'blockquote',
  q: 'q',
  code: 'code',
  i: 'i',
  small: 'small',
  label: 'label',
  default: 'p'
};

/**
 * @component Text
 */
const Text = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    children,
    className,
    sx,
    as = 'p',
    rawHTML,
    onClick
  } = props;
  const Tag = TAGS[as] ?? TAGS['p'];
  const tagProps = {
    ref: ref,
    css: sx,
    className: cx('block', className),
    onClick: onClick
  };
  if (rawHTML) return ___EmotionJSX(Tag, _extends({}, tagProps, {
    dangerouslySetInnerHTML: {
      __html: children
    }
  }));
  return ___EmotionJSX(Tag, tagProps, children);
});
Text.displayName = 'Text';
Text.propTypes = propTypes;
Text.defaultProps = defaultProps;
export default WithSx(Text, {});